const defaults = {
    dom: `<'row'<'col-sm-12 align-content:left'f>>" + "<'row'<'col-sm-12'tr >>" + "<'row'<'col-sm-4'l><'col-sm-4 text-center'i><'col-sm-4'p>>`,
    //domButtons: `<'row'<'col-sm-6 align-content:left'f><'col-sm-6 text-right'B>>" + "<'row'<'col-sm-12'tr >>" + "<'row'<'col-sm-4'l><'col-sm-4 text-center'i><'col-sm-4'p>>`,

    language: {
        search: '_INPUT_',
        searchPlaceholder: 'Filtrar...',
        lengthMenu: 'Ver <select class="input-sm">' +
            '<option value="20">20</option>' +
            '<option value="50">50</option>' +
            '<option value="100">100</option>' +
            '</select> registros',
        paginate: {
            previous: '&laquo;',
            next: '&raquo;'
        },
        info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando 0 a 0 de 0 registros",
        loadingRecords: "Cargando...",
        processing: "Cargando, espere por favor...",
        zeroRecords: "Sin resultados encontrados",
        infoFiltered: "(filtrado de un total de _MAX_ registros)",
        select: {
            rows: {
                _: "%d filas seleccionadas",
                0: "Seleccione una fila",
                1: "Una fila seleccionada"
            }
        }
    },

    perPage: 20,


    //tableClass: 'display',
    tableClass: 'table table-hover table-striped display no-wrap responsive' , //table table-hover display responsive no-wrap
}

/**
 * Merge the given options into the default options.
 *
 * @param {Object} options
 */
const merge = function merge(options) {
    Object.assign(defaults, options)
}

export { merge }
export default defaults